import gsap from 'gsap'
import { each } from 'lodash'

export default class Pagination {
    constructor() {
        this.pagination = document.querySelector('[data-pagination-async]')
        this.links = this.pagination.querySelectorAll('a')
        this.list = document.getElementById('list')
        this.counter = {
            element: document.querySelector('span[data-counter]'),
            total: Number(document.querySelector('span[data-total]').innerHTML),
            value: 0
        }

        this.page = {
            old: undefined,
            current: Number(this.pagination.querySelector('span.current[data-current-page]').innerHTML),
            total: Number(this.pagination.querySelector('a.next.double').getAttribute('data-current-page'))
        }

        console.log(this.page, this.counter)

        this.counter.element.innerHTML = (this.page.current == this.page.total) ? this.counter.total : (this.page.current * 10)

        this.addLinkListeners();
    }

    // On Page Change
    async onChange({ url, currentPage, push = true }) {
        var counter = this.counter.value

        gsap.to(this.list, {
            duration: 1,
            autoAlpha: 0
        })

        const request = await window.fetch(url)

        if (request.status === 200) {
            const html = await request.text(),
                div = document.createElement('div');

            if (push) { window.history.pushState({}, '', url) }

            div.innerHTML = html;

            const newList = div.querySelector('#list'),
                newPagination = div.querySelector('[data-pagination-async]');

            this.page.old = Number(this.pagination.querySelector('span.current[data-current-page]').innerHTML)

            this.list.innerHTML = newList.innerHTML
            this.pagination.innerHTML = newPagination.innerHTML

            this.pagination = document.querySelector('[data-pagination-async]')
            this.links = this.pagination.querySelectorAll('a')

            this.page.current = Number(currentPage)
            this.counter.value = (this.page.current == this.page.total) ? this.counter.total : (this.page.current * 10)

            this.counter.element.innerHTML = this.counter.value

            gsap.to(this.list, {
                duration: 1,
                autoAlpha: 1
            })

            this.addLinkListeners()
        } else {
            console.log('Error')
        }

    }

    addLinkListeners() {
        const links = this.links;

        each(links, (link) => {
            link.onclick = (event) => {
                event.preventDefault();

                const { href } = link,
                    page = link.getAttribute('data-page');

                this.onChange({ url: href, currentPage: page });
            }
        })
    }
}